import { BidStatus, SupplierStanding } from "../../../../autogen/bff-api";
import { BidStatusTag } from "../../../sourcing-event/BidStatusTag";
import { RoundAnswerTag } from "../../../sourcing-event/RoundAnswerTag";
import type { RoundAnswer } from "../../../sourcing-event/supplierRows";

const roundAnswers: Partial<Record<SupplierStanding, RoundAnswer>> = {
  [SupplierStanding.NewBid]: "NewBid",
  [SupplierStanding.ConfirmedStandingBid]: "ConfirmedStandingBid",
  [SupplierStanding.Declined]: "Declined",
  [SupplierStanding.NoAnswer]: "NoAnswer",
  [SupplierStanding.Awaiting]: "Awaiting",
};

export const SupplierStandingTag = ({
  standing,
}: {
  standing: SupplierStanding;
}) => {
  const roundAnswer = roundAnswers[standing];
  if (roundAnswer) return <RoundAnswerTag answer={roundAnswer} />;
  switch (standing) {
    case SupplierStanding.Awarded:
      return <BidStatusTag status={BidStatus.Awarded} />;
    case SupplierStanding.Rejected:
      return <BidStatusTag status={BidStatus.Rejected} />;
    case SupplierStanding.NotSelected:
      return <BidStatusTag status={BidStatus.Submitted} awarded />;
    default:
      return <BidStatusTag status={BidStatus.Submitted} />;
  }
};
